const initialState = {
  groupId: null,
};

export default function boardFilter(state = initialState, action) {
  switch (action.type) {
    case "SET_BOARD_FILTER":
      return { groupId: action.groupId };
  }
  return state;
}
